import { Pipe, PipeTransform } from '@angular/core';
import { ComputeValuePipe, EConfigurableTableFields, TComputeValueInput } from "libraries/pipes/configurable-table/compute-value.pipe";
import { IBookingSearchResultConfig } from "../../interfaces/IConfigurableTable";
import { FindColumnByKeyPipe } from "./find-column-by-key.pipe";

@Pipe({
    name: 'canCreateTd',
})

export class CanCreateTdPipe implements PipeTransform {
    constructor(
        private findColumnByKey: FindColumnByKeyPipe,
        private computeValue: ComputeValuePipe,
    ) {
    }

    public transform(element: TComputeValueInput, columnIndex: number, rowIndex: number, bookingIndex: number, isFixedTd: boolean,
                     isLast: boolean, columnArrayToDisplay: string[][], config: IBookingSearchResultConfig,
                     pathByElementKey: { [key: string]: string }): boolean {
        const columnKey: string = columnArrayToDisplay[rowIndex][columnIndex];
        if (isFixedTd) {
            if (columnIndex === 0) {
                return this.transform(element, columnIndex + 1, rowIndex, bookingIndex, false, false, columnArrayToDisplay, config, pathByElementKey);
            }
            if (isLast) {
                return this.transform(element, 1, rowIndex, bookingIndex, false, false, columnArrayToDisplay, config, pathByElementKey);
            }
            return true;
        }

        if (this.findColumnByKey.transform(columnKey, config)?.groupArray?.length) {
            return true;
        }
        return this.findColumnByKey.transform(columnKey, config)?.fieldKeyArray?.every((fieldKey: EConfigurableTableFields): boolean => {
                return Boolean(this.computeValue.transform(element, fieldKey, pathByElementKey[fieldKey]));
            }
        );
    }
}
